import { render, staticRenderFns } from "./BuildingManagementViewMain.vue?vue&type=template&id=171ba78f"
import script from "./BuildingManagementViewMain.vue?vue&type=script&lang=js"
export * from "./BuildingManagementViewMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports